import React from "react";
import { FavouriteButton } from "../../../../favourites/components";
import { useFavouriteProviderContext } from "../../../shared";

export const Favourite: React.FC = () => {
  const {
    state: { isFavouriteLoading, isFavouriteDisabled, savedFavouriteItem },
    actions: { addFavourite, deleteFavourite },
  } = useFavouriteProviderContext();

  return (
    <FavouriteButton
      isLoading={isFavouriteLoading}
      isDisabled={isFavouriteDisabled}
      handleAdd={addFavourite}
      handleDelete={deleteFavourite}
      favouriteItem={savedFavouriteItem}
    />
  );
};
